module.exports = __webpack_public_path__ + "assets/img/under.7d5169f2.svg";